// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__FShpq","title":"Info_title__3k3Y5","links":"Info_links__3hAxb","link":"Info_link__2NbCK","logo":"Info_logo__3n0Sh"};